import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'
const header = (isFranchise = false) => [
  {
    label: 'S.N',
    value: 'id',
  },
  {
    label: 'Date',
    value: 'date',
  },
  {
    label: 'Transaction id',
    value: 'orderId',
  },
  {
    label: 'Material Hub',
    value: 'pickupPointName',
  },
  {
    label: 'Transaction type',
    value: 'transactionType',
  },
  {
    label: 'Qunantity',
    value: 'supplied',
  },
  {
    label: 'Amount',
    value: 'amount',
  },
]

const roleColumns = (isFranchise = false) => {
  return columnGenerators(header(isFranchise))
}
export { roleColumns }
